import React, {useState} from "react";
import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {useProposal} from "../../../hooks/useProposal";
import {baseUrl, LocalUrl} from "../../../services/AxiosInstance";
import {useParams} from "react-router-dom";
import Loader from "../shared/Loader";

function PaymentSheet({intervention}) {
  const stripe = useStripe();
  const {id: interventionId} = useParams();

  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handlePay = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    try {
      // Call your backend endpoint to create the payment intent

      // Initialize Stripe Elements (similar to initPaymentSheet in React Native)
      const {error} = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: !!intervention
            ? LocalUrl + "/intervention/paiement/confirmer/" + interventionId
            : LocalUrl + "/paiement/confirmer/", // Replace with your success page
        },
      });

      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occurred.");
      }
    } catch (error) {
      setMessage(
        error?.message || "Le paiement n'a pas pu être confirmé. Veuillez réessayer.",
      );
    } finally {
      setIsLoading(false);
    }
  };
  const paymentElementOptions = {
    layout: "accordion",
  };

  return (
    <form
      id="payment-form"
      className="w-5/6  md:w-3/4 xl:w-1/2 !mb-4"
      onSubmit={handlePay}
    >
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button
        disabled={isLoading || !stripe || !elements}
        data-testid="payment-submit"
        className="btn  !p-0 w-full h-[47px] mt-2 rounded-lg text-[12px] flex justify-center items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white capitalize-first "
        id="submit"
      >
        <span id="button-text">{isLoading ? <Loader /> : "Payer "}</span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}

export default PaymentSheet;
